import { render, staticRenderFns } from "./indivual.vue?vue&type=template&id=06fc063b&"
import script from "./indivual.vue?vue&type=script&lang=js&"
export * from "./indivual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports